// src/navigation/navigation.config.js
// Single source of truth for navigation

export const NAV = {

  admin: {
  top: [
    { key: "dashboard", label: "Dashboard", base: "/admin/dashboard" },
    { key: "orders", label: "Orders", base: "/admin/orders" },
    { key: "payments", label: "Payments", base: "/admin/payments" },
    { key: "support", label: "Support", base: "/admin/support" },
    { key: "users", label: "Users", base: "/admin/users" },
    { key: "settings", label: "Settings", base: "/admin/settings" },
  ],

  sections: {
    dashboard: {
      title: "Dashboard",
      items: [
        { label: "Overview", path: "/admin/dashboard" },
      ],
    },

    orders: {
      title: "Orders",
      items: [
        { label: "Order List", path: "/admin/orders" },
        // Details route will be opened by clicking an order:
        // /admin/orders/:orderId
      ],
    },

    payments: {
      title: "Payments",
      items: [
        { label: "Payments Ledger", path: "/admin/payments" },
        { label: "Refunds", path: "/admin/payments/refunds" },
        { label: "Driver Payouts", path: "/admin/payments/payouts" },
      ],
    },

    support: {
      title: "Support",
      items: [
        { label: "Tickets", path: "/admin/support" },
        { label: "Disputes", path: "/admin/support/disputes" },
      ],
    },

    users: {
      title: "Users",
      items: [
        { label: "Customers", path: "/admin/users/customers" },
        { label: "Drivers", path: "/admin/users/couriers" },
      ],
    },

   settings: {
     title: "Settings",
     items: [
       { label: "General", path: "/admin/settings" },
       { label: "Pricing Rules (planned)", path: "/admin/settings/pricing", disabled: true },
       { label: "Promo Rules (planned)", path: "/admin/settings/promos", disabled: true },
     ],
   }

  },
},

    customer: {
    top: [
      { key: "dashboard", label: "Dashboard", base: "/customer/dashboard" },
      { key: "orders", label: "Loads", base: "/customer/track-package" },
      { key: "payments", label: "Payments", base: "/customer/payment-management" },
      { key: "messages", label: "Updates", base: "/customer/customer-notifications" },
      { key: "help", label: "Help", base: "/customer/support-and-help-center" },
      { key: "account", label: "Account", base: "/customer/customer-profile" },
    ],


    sections: {
      dashboard: {
        title: "Dashboard",
        items: [
          { label: "Overview", path: "/customer/dashboard" },
        ],
      },

      orders: {
       title: "Loads",
        items: [
          { label: "Track Load", path: "/customer/track-package" },
          { label: "Load History", path: "/customer/order-history" },
          { label: "Load Customization", path: "/customer/order-customization" },
        ],
      },

      payments: {
        title: "Payments",
          items: [
            { label: "Payments", path: "/customer/payment-management" },
            { label: "Membership", path: "/customer/subscription-management" },
            { label: "Launch Offers", path: "/customer/promotions-and-discounts" },
            { label: "Referrals", path: "/customer/referral-program" },
         ],
       },

      messages: {
        title: "Updates",
           items: [
             { label: "Driver Communication", path: "/customer/customer-courier-communication" },
             { label: "Notifications", path: "/customer/customer-notifications" },
             { label: "Live Chat", path: "/customer/live-chat" },
          ],
       },

      
      help: {
        title: "Help",
           items: [
            { label: "Support Center", path: "/customer/support-and-help-center" },
            { label: "Knowledge Base", path: "/customer/knowledge-base" },
            { label: "Getting Started", path: "/customer/getting-started-guides" },
            { label: "Documentation", path: "/customer/product-documentation" },
            { label: "Submit Ticket", path: "/customer/ticket-system" },

         // optional (you have it):
         // { label: "Ticket System", path: "/customer/ticket-system" },

          // optional:
         // { label: "Community Forums", path: "/customer/community-forums" },
        ],
      },

      account: {
        title: "Account",
          items: [
             { label: "Profile", path: "/customer/customer-profile" },
             { label: "Settings & Preferences", path: "/customer/customer-settings-and-preferences" },
            { label: "Language & Localization", path: "/customer/language-localization" }, 
             { label: "Feedback & Ratings", path: "/customer/feedback-ratings" },
          ],
      },


    },
  },

   courier: {
    top: [
      { key: "dashboard", label: "Dashboard", base: "/courier/dashboard" },

      // Use REAL pages as bases (the ones that stay in the address bar)
      { key: "work", label: "Loads", base: "/courier/available-orders" },
      { key: "earnings", label: "Earnings", base: "/courier/payment-and-invoicing" },
      { key: "help", label: "Help", base: "/courier/support-and-help-center-courier" },
      { key: "account", label: "Account", base: "/courier/courier-profile" },
    ],



    sections: {
      dashboard: {
        title: "Dashboard",
        items: [
          { label: "Overview", path: "/courier/dashboard" },
        ],
      },

     work: {
       title: "Loads",
       items: [
         { label: "Available Loads", path: "/courier/available-orders" },
         { label: "My Loads", path: "/courier/order-management" },
         { label: "Route Planner", path: "/courier/delivery-routes" },
         { label: "Completion", path: "/courier/proof-of-delivery" },
      ],
    },

    earnings: {
  title: "Earnings",
  items: [
    { label: "Earnings & Payouts", path: "/courier/payment-and-invoicing" },
    { label: "Performance", path: "/courier/performance-analytics" },
  ],
},

     help: {
  title: "Help",
  items: [
    { label: "Support Center", path: "/courier/support-and-help-center-courier" },
    { label: "Contact Support", path: "/courier/emergency-assistance" },
  ],
},


      account: {
        title: "Account",
        items: [
          { label: "Driver / Carrier Profile", path: "/courier/courier-profile" },
          { label: "Settings", path: "/courier/settings-preferences" },
       // { label: "Language & Localization", path: "/courier/language-localization" }, //
          { label: "Shift Scheduling", path: "/courier/shift-scheduling" },
          { label: "Vehicle Maintenance", path: "/courier/vehicle-maintenance" },
          { label: "Referrals", path: "/courier/referrals", },
        ],
      },

    },
  },
};
